import { graphql, useStaticQuery } from "gatsby";

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteImage
          description
          image
          logo
          siteUrl
        }
      }
    }
  `);

  return data.site.siteMetadata;
};
